module.exports = __webpack_public_path__ + "assets/images/4825e09d3f6dfed28282c008aa7b09e8.png";